import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import { isDefined, functor } from "../utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

class AlligatorTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      onClick,
      fontFamily,
      fontSize,
      displayFormat,
      className,
      yAccessor,
      options,
      appearance,
      labelFill,
      textFill,
    } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);

    let jaw = "n/a";
    let teeth = "n/a";
    let lips = "n/a";

    if (isDefined(currentItem) && isDefined(yAccessor(currentItem))) {
      const item = yAccessor(currentItem);
      jaw = isDefined(item.jaw) ? displayFormat(item.jaw) : "n/a";
      teeth = isDefined(item.teeth) ? displayFormat(item.teeth) : "n/a";
      lips = isDefined(item.lips) ? displayFormat(item.lips) : "n/a";
    }

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const jawColor = appearance?.strokeJaw?.color || "#0000FF";
    const teethColor = appearance?.strokeTeeth?.color || "#FF0000";
    const lipsColor = appearance?.strokeLips?.color || "#00DD00";

    const { jawPeriod, teethPeriod, lipsPeriod } = options || {};

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-alligator"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>
            {`Alligator (${jawPeriod ?? "?"}, ${teethPeriod ?? "?"}, ${lipsPeriod ?? "?"}): `}
          </ToolTipTSpanLabel>
          <ToolTipTSpanLabel fill={labelFill}>Jaw: </ToolTipTSpanLabel>
          <tspan fill={jawColor}>{jaw}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> Teeth: </ToolTipTSpanLabel>
          <tspan fill={teethColor}>{teeth}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> Lips: </ToolTipTSpanLabel>
          <tspan fill={lipsColor}>{lips}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

AlligatorTooltip.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  displayFormat: PropTypes.func.isRequired,
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  onClick: PropTypes.func,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  options: PropTypes.shape({
    jawPeriod: PropTypes.number,
    teethPeriod: PropTypes.number,
    lipsPeriod: PropTypes.number,
  }),
  appearance: PropTypes.object,
  textFill: PropTypes.string,
  labelFill: PropTypes.string,
};

AlligatorTooltip.defaultProps = {
  origin: [0, 0],
  className: "react-stockcharts-tooltip react-stockcharts-alligator-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor,
  labelFill: "#6B7280",
  textFill: "#F9FAFB",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 12,
};

export default AlligatorTooltip;
